export enum Errors {
  "NotFound" = "Not found",
  "ServerError" = "Internal server error",
  "LoginAttemptExceeded" = "Login attempt limit exceeded. Please try again later.",
}
